<section id="ngx">
    <div class="card card-onboarding">
        <div class="card-content">
            <div class="card-body">

                <aw-wizard #wizard [disableNavigationBar]="true" class="wizard-onboarding">
                    <aw-wizard-step [stepTitle]="'Step 1'"
                        [navigationSymbol]="{ symbol: '&#xf007;', fontFamily: 'FontAwesome' }"
                        style="background-image: url(../../../../assets/img/confetti.png);background-size: cover;">
                        <p>
                            <ngb-progressbar type="warning" [value]="25"></ngb-progressbar>
                        </p>
                        <div class='row'>
                            <div class="col-12">
                                <h4 class="onboarding-step-1-header-title text-center">SURPRESA!</h4>
                                <p class="text-center onboarding-step-1-subheadline">Você acaba de ganhar uma
                                    <b>oportunidade
                                        única</b>, por tempo limitado!
                                </p>
                            </div>

                        </div>

                        <div class='row ml-md-3 d-lg-none'>

                            <div class="col-12 col-lg-3" style="text-align: center">
                                <img src="../../../../assets/img/2months2.png" class="onboarding-step-1-plan-features">
                            </div>
                            <div class="col-12 col-lg-1 " style="text-align: center;">
                                <img src="../../../../assets/img/plus.svg" class="plus-sign">
                            </div>
                            <div class="col-12 col-lg-3" style="text-align: center">
                                <img src="../../../../assets/img/Mentoria_Mensal.svg"
                                    class="onboarding-step-1-plan-features">
                            </div>
                            <div class="col-12 col-lg-1" style="text-align: center;">
                                <img src="../../../../assets/img/plus.svg" class="plus-sign">
                            </div>
                            <div class="col-12 col-lg-3" style="text-align: center">
                                <img src="../../../../assets/img/Bonus_Exclusivos.svg"
                                    class="onboarding-step-1-plan-features">
                            </div>

                        </div>

                        <div class='row d-none d-lg-flex'>

                            <div class="col-12" style="text-align: center">
                                <img src="../../../../assets/img/premios_tela1.svg" style="width: 80%;">
                            </div>
                                                    </div>

                        <div class='row onboarding-offer-row'>
                            <div class='col-12'>
                                <h5 class="text-center onboarding-step-1-plan-info">(No Plano Anual)</h5>
                            </div>
                        </div>
                        <div class='row onboarding-btn-timer'>
                            <div class='col-12'>
                                <span *ngIf="configTimer.leftTime>0">
                                    <p class="text-center onboarding-step-1-counter">Esta oferta sai do ar em <b>
                                            <countdown [config]="configTimer"></countdown>
                                        </b>
                                    </p>
                                </span>
                            </div>

                            <div class='col-12'>
                                <div class="form-group text-center mb-0">
                                    <button type="button" class="btn btn-warning btn-lg onboarding-step-1-btn-offer"
                                        (click)="updateOnboardingProgress(2, null, true)">Garantir Oportunidade</button>
                                </div>
                            </div>

                            <div class='col-12'>
                                <h3 class="text-center onboarding-step-1-or-text">ou</h3>
                            </div>

                            <div class='col-12'>
                                <div class="form-group text-center">
                                    <button type="button" class="btn btn-light btn-lg onboarding-step-1-btn-start-test"
                                        awNextStep (click)="updateOnboardingProgress(3, null, false)">Iniciar Teste
                                        Grátis</button>
                                </div>
                            </div>

                        </div>
                    </aw-wizard-step>
                    <aw-wizard-step [stepTitle]="'Step 2'"
                        [navigationSymbol]="{ symbol: '&#xf007;', fontFamily: 'FontAwesome' }">
                        <p>
                            <ngb-progressbar type="warning" [value]="50"></ngb-progressbar>
                        </p>
                        <div class='row'>
                            <div class="col-12">
                                <p class="text-center onboarding-step-2-subheadline">Quantos alunos você atende online e
                                    presencialmente?</p>
                                <div class='col-12'>
                                    <p class="text-center onboarding-step-2-click-text">(Clique em uma das opções)</p>
                                </div>
                            </div>

                        </div>
                        <div class='row ml-md-3 row-alunos'>
                            <div class="col-12 col-md-4" style="text-align: center">
                                <button type="button" class="btn btn-outline-primary btn-lg btn-customer-number"
                                    (click)="updateOnboardingProgress(4, 1, false)" awNextStep>
                                    <span class="customer-text">Até</span><br>
                                    <span class="customer-number">5</span><br>
                                    <span class="customer-text">alunos</span>
                                </button>
                            </div>
                            <div class="col-12 col-md-4" style="text-align: center">
                                <button type="button" class="btn btn-outline-primary btn-lg btn-customer-number"
                                    (click)="updateOnboardingProgress(4, 2, false)" awNextStep>
                                    <span class="customer-text">Entre</span><br>
                                    <span class="customer-number">6-15</span><br>
                                    <span class="customer-text">alunos</span>
                                </button>
                            </div>
                            <div class="col-12 col-md-4" style="text-align: center">
                                <button type="button" class="btn btn-outline-primary btn-lg btn-customer-number"
                                    (click)="updateOnboardingProgress(4, 3, false)" awNextStep>
                                    <span class="customer-text">Mais de</span><br>
                                    <span class="customer-number">15</span><br>
                                    <span class="customer-text">alunos</span>
                                </button>
                            </div>
                        </div>


                        <div class='row'>
                            <div class='col-12'>
                                <div class="form-group d-md-none text-center mt-1">
                                    <button type="button" class="btn btn-light btn-lg onboarding-btn-back-step2" awPreviousStep>Voltar</button>
                                </div>

                                <div class="form-group d-none d-md-flex">
                                    <button type="button" class="btn btn-light btn-lg onboarding-btn-back-step2" awPreviousStep>Voltar</button>
                                </div>
                            </div>
                        </div>
                    </aw-wizard-step>
                    <aw-wizard-step [stepTitle]="'Step 3'"
                        [navigationSymbol]="{ symbol: '&#xf0ac;', fontFamily: 'FontAwesome' }">
                        <p>
                            <ngb-progressbar type="warning" [value]="100"></ngb-progressbar>
                        </p>
                        <div class='row'>
                            <div class="col-12">
                                <h4 class="onboarding-step-3-header-title text-center">Parabéns pelo seu cadastro, Personal!</h4>
                                <p class="text-center onboarding-step-3-subheadline">Agora, convide o seu aluno para baixar o app e ganhe uma planilha de controle financeiro.</p>
                            </div>

                        </div>

                        <div class="row">
                            <div class="col-12" style="text-align: center">
                                <img src="../../../../assets/img/presente-confetti.svg" class="onboarding-img-plane">
                            </div>
                        </div>

                        <div class='row'>
                            <div class="col-12">
                                <p class="text-center onboarding-step-3-help-text-1">O link de convite foi copiado!</p>
                                <p class="text-center onboarding-step-3-help-text"><b>Clique no botão abaixo e envie
                                        para
                                        seus alunos:</b></p>
                                <div class="form-group text-center">
                                    <button class="btn btn-success btn-lg onboarding-btn-whatsapp"
                                        (click)="cancelarWhatsApp()"><i class="fa fa-whatsapp"></i>
                                        Compartilhar</button>
                                </div>
                            </div>
                        </div>
                        <div class="row row-footer d-md-none">
                            <div class="col-12 col-lg-6">
                                <div class="form-group text-center">
                                    <button type="button" class="btn btn-light btn-lg onboarding-btn-go-plataform" (click)="updateOnboardingProgress(5, null, false)"><i
                                            class="ft ft-log-in"></i> Acessar Plataforma</button>
                                </div>
                            </div>
                            <div class="col-12 col-lg-6">
                                <div class="form-group text-center">
                                    <button type="button" class="btn btn-light btn-lg onboarding-btn-back"
                                        awPreviousStep>Voltar</button>
                                </div>
                            </div>

                        </div>
                        <div class="row row-footer d-none d-md-flex">
                            <div class="col-6">
                                <div class="form-group">
                                    <button type="button" class="btn btn-light btn-lg onboarding-btn-back float-left"
                                        awPreviousStep>Voltar</button>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="form-group">
                                    <button type="button"
                                        class="btn btn-light btn-lg onboarding-btn-go-plataform float-right" (click)="updateOnboardingProgress(5, null, false)"><i
                                            class="ft ft-log-in"></i> Acessar Plataforma</button>
                                </div>
                            </div>
                        </div>
                    </aw-wizard-step>
                </aw-wizard>


            </div>
        </div>
    </div>
</section>